module.exports = __webpack_public_path__ + "static/media/onepay.c0e27a5b.png";